import { takeEvery, all, call, put } from 'redux-saga/effects';
import * as types from './stockActionTypes';
import * as actions from './stockActions';
import * as endpoints from '../../services/endpoints';
import * as alert from '../alert/alertActions';

function* getStockSaga(action) {
  try {
    const { data } = yield call(endpoints.getStock, action.payload);
    yield put(actions.getStockSuccess(data));
  } catch (e) {
    yield put(actions.getStockError(e));
  }
}

function* addStockSaga(action) {
  try {
    const { data } = yield call(endpoints.addStock, action.payload);
    yield put(actions.addStockSuccess(data));
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(alert.setAlertAction({
        title: 'Başarılı!',
        text: 'Stok başarıyla oluşturuldu',
        variant: 'success',
      }));
      if (action.payload.navigate) {
        setTimeout(() => {
          action.payload.navigate('/stock');
        }, 1500);
      }
    }
  } catch (e) {
    yield put(actions.addStockError(e));
  }
}

function* updateStockSaga(action) {
  try {
    const { data } = yield call(endpoints.updateStock, action.payload);
    yield put(actions.updateStockSuccess(data));
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(alert.setAlertAction({
        title: 'Başarılı!',
        text: 'Stok başarıyla güncellendi',
        variant: 'success',
      }));
      if (action.payload.navigate) {
        setTimeout(() => {
          action.payload.navigate('/stock');
        }, 1000);
      }
    }
  } catch (e) {
    yield put(actions.updateStockError(e));
  }
}

function* deleteStockSaga(action) {
  try {
    const { data } = yield call(endpoints.deleteStock, action.payload);
    yield put(actions.deleteStockSuccess(data));
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(alert.setAlertAction({
        title: 'Başarılı!',
        text: 'Stok başarıyla silindi',
        variant: 'success',
      }));
      yield put(actions.getStockRequest({}));
    }
  } catch (e) {
    yield put(actions.deleteStockError(e));
  }
}

function* watchGetStock() {
  yield takeEvery(types.GET_STOCK_REQUEST, getStockSaga);
}
function* watchAddStock() {
  yield takeEvery(types.ADD_STOCK_REQUEST, addStockSaga);
}
function* watchUpdateStock() {
  yield takeEvery(types.UPDATE_STOCK_REQUEST, updateStockSaga);
}
function* watchDeleteStock() {
  yield takeEvery(types.DELETE_STOCK_REQUEST, deleteStockSaga);
}

export function* stockSaga() {
  yield all([
    watchGetStock(),
    watchAddStock(),
    watchUpdateStock(),
    watchDeleteStock(),
  ]);
} 